import { useEffect, useState } from "react";

// 24/7 KI-Sales-Agent — animierte Demo (dark/green, BA Media)
// Drop-in: <AiSalesAgentDemo /> in eine Section einsetzen.
// Keine externen Abhängigkeiten (kein framer-motion nötig) — reines React + CSS.

const C = {
  bg: "#0c0d10", panel: "#14161b", panel2: "#181b21", border: "#23262d",
  green: "#3DDC97", greenDim: "rgba(61,220,151,0.12)", text: "#E7E4DC",
  sub: "#8b8880", muted: "#6f6d66", white: "#ffffff",
};

const MSG = {
  q: { side: "user", text: "Können Sie mein Flachdach abdichten? Ca. 90 m², Altbau." },
  a1: { side: "agent", text: "Ja, Flachdachabdichtung bei Altbau machen wir oft. Der Preis hängt von Dämmung und Zustand ab — damit ein Meister Ihnen ein genaues Angebot macht: Wie ist Ihr Name und Ihre Handynummer?" },
  c: { side: "user", text: "Stefan B., 0151 •••••••" },
  a2: { side: "agent", text: "Danke, Herr Brandt! Ihre Anfrage liegt jetzt bei uns — Sie hören heute von uns." },
};

export default function AiSalesAgentDemo() {
  const [shown, setShown] = useState([]);
  const [typing, setTyping] = useState(false);
  const [lead, setLead] = useState(false);
  const [value, setValue] = useState(false);

  useEffect(() => {
    let alive = true;
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    const stop = () => !alive;
    async function loop() {
      while (alive) {
        setShown([]); setTyping(false); setLead(false); setValue(false);
        await sleep(800); if (stop()) return;
        setShown((s) => [...s, MSG.q]); await sleep(1200); if (stop()) return;
        setTyping(true); await sleep(1600); if (stop()) return; setTyping(false);
        setShown((s) => [...s, MSG.a1]); await sleep(2700); if (stop()) return;
        setShown((s) => [...s, MSG.c]); await sleep(1000); if (stop()) return;
        setTyping(true); await sleep(1300); if (stop()) return; setTyping(false);
        setShown((s) => [...s, MSG.a2]); await sleep(800); if (stop()) return;
        setLead(true); await sleep(700); if (stop()) return; setValue(true);
        await sleep(4500); if (stop()) return;
      }
    }
    loop();
    return () => { alive = false; };
  }, []);

  const row = (k, v, accent) => (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 10, padding: "9px 2px", borderBottom: `1px solid ${C.border}`, fontSize: 13 }}>
      <span style={{ color: C.sub }}>{k}</span>
      <span style={{ color: accent ? C.green : C.text, textAlign: "right", fontWeight: accent ? 700 : 400 }}>{v}</span>
    </div>
  );

  return (
    <div style={{ fontFamily: "inherit", color: C.text }}>
      <style>{`
        @keyframes baPop{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
        @keyframes baBlink{0%,100%{opacity:1}50%{opacity:.25}}
        @keyframes baDot{0%,100%{opacity:.3;transform:translateY(0)}50%{opacity:1;transform:translateY(-3px)}}
        .ba-pop{animation:baPop .45s ease both}
        .ba-dot{width:6px;height:6px;border-radius:50%;background:${C.muted};display:inline-block;animation:baDot 1s infinite}
        .ba-dot:nth-child(2){animation-delay:.15s}.ba-dot:nth-child(3){animation-delay:.3s}
      `}</style>

      {/* Status-Leiste */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12, padding: "11px 15px", marginBottom: 14, fontSize: 13, color: C.sub }}>
        <span>03:14 Uhr · der Chef schläft</span>
        <span style={{ display: "flex", alignItems: "center", gap: 8, color: C.green }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: C.green, animation: "baBlink 1.4s infinite" }} />
          KI Sales-Agent aktiv
        </span>
      </div>

      <div style={{ display: "flex", gap: 16, alignItems: "flex-start", flexWrap: "wrap" }}>
        {/* Phone / Chat */}
        <div style={{ flex: "1 1 280px", minWidth: 260, background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 13px", borderBottom: `1px solid ${C.border}`, fontSize: 13, fontWeight: 700 }}>
            <span style={{ width: 30, height: 30, borderRadius: "50%", background: C.green, color: "#0c2a1c", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 12 }}>BA</span>
            BA Media Assistent
          </div>
          <div style={{ padding: 12, display: "flex", flexDirection: "column", gap: 9, minHeight: 250 }}>
            {shown.map((m, i) => (
              <div key={i} className="ba-pop" style={{
                maxWidth: "86%", padding: "8px 11px", borderRadius: 12, fontSize: 13, lineHeight: 1.45,
                alignSelf: m.side === "user" ? "flex-end" : "flex-start",
                background: m.side === "user" ? C.green : C.panel2,
                color: m.side === "user" ? "#0c2a1c" : C.text,
                border: m.side === "user" ? "none" : `1px solid ${C.border}`,
                borderBottomRightRadius: m.side === "user" ? 3 : 12,
                borderBottomLeftRadius: m.side === "user" ? 12 : 3,
              }}>{m.text}</div>
            ))}
            {typing && (
              <div className="ba-pop" style={{ alignSelf: "flex-start", display: "flex", gap: 4, padding: "11px 12px", background: C.panel2, border: `1px solid ${C.border}`, borderRadius: 12, borderBottomLeftRadius: 3 }}>
                <span className="ba-dot" /><span className="ba-dot" /><span className="ba-dot" />
              </div>
            )}
          </div>
        </div>

        {/* Backend */}
        <div style={{ flex: "1 1 320px", minWidth: 280, background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
          <div style={{ padding: "11px 13px", borderBottom: `1px solid ${C.border}`, fontSize: 13, fontWeight: 700 }}>Backend · Anfragen</div>
          <div style={{ padding: 12, minHeight: 250, display: "flex", flexDirection: "column" }}>
            {!lead ? (
              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: C.muted, fontSize: 13 }}>
                wartet auf neue Anfragen …
              </div>
            ) : (
              <div className="ba-pop">
                <div style={{ display: "flex", alignItems: "center", gap: 8, background: C.greenDim, color: C.green, fontWeight: 700, fontSize: 13, padding: "9px 11px", borderRadius: 8, marginBottom: 10 }}>
                  ✓ neue Anfrage automatisch gespeichert
                </div>
                {row("Name", "Stefan B.")}
                {row("Anliegen", "Flachdach abdichten, 90 m²")}
                {row("Telefon", "0151 •••••••")}
                {row("Eingang", "03:14 Uhr")}
                {row("Status", "neu")}
                {row("Relevanz", "9 / 10", true)}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 3-Schritt-Leiste */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 16, flexWrap: "wrap" }}>
        {["Kunde fragt", "Agent berät sofort", "Im Backend gespeichert"].map((s, i) => (
          <span key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 10, padding: "8px 13px", fontSize: 13 }}>{s}</span>
            {i < 2 && <span style={{ color: C.green, fontWeight: 700 }}>→</span>}
          </span>
        ))}
      </div>

      {/* Value-Line */}
      <div style={{ textAlign: "center", marginTop: 14, fontSize: 14, color: C.text, opacity: value ? 1 : 0, transition: "opacity .5s" }}>
        Mitten in der Nacht beraten und gespeichert — <span style={{ color: C.green, fontWeight: 700 }}>kein Lead geht verloren.</span>
      </div>
    </div>
  );
}
